import axios from 'axios'

import { baseURL } from '..'

/**
 * LIST
 * Retorna uma lista de subpublisher de uma campanha
 * https://newtail-docs-git-get-subpublishers-newtail.vercel.app/retail-media/get-subpublishers-by-campaign
 */
export const listCampaignSubpublishersKey = 'listCampaignSubpublishers'
export const listCampaignSubpublishersService = ({
  id,
  params
}: ListCampaignSubpublishersResquest) =>
  axios.get<ListCampaignSubpublisherResponse>(`${baseURL}/${id}/subpublisher`, {
    params
  })

/**
 * Patch
 * Editar o status de um subpublisher em uma campanha
 * https://newtail-docs-git-get-subpublishers-newtail.vercel.app/retail-media/update-subpublisher-by-campaign
 */
export const patchCampaignSubpublishersKey = 'patchCampaignSubpublishers'
export const patchCampaignSubpublishersService = ({
  subpublisherId,
  body
}: PatchCampaignSubpublishersResquest) =>
  axios.patch<ListCampaignSubpublisherResponse>(
    `${baseURL}/subpublisher/${subpublisherId}`,
    body
  )

/**
 * Add bulk on campaign
 * https://newtail-docs-git-get-subpublishers-newtail.vercel.app/retail-media/add-subpublisher-to-campaign
 */
export const addBulkCampaignSubpublishersKey = 'addBulkCampaignSubpublishers'
export const addBulkCampaignSubpublishersService = ({
  id,
  body
}: AddBulkCampaignSubpublishersResquest) =>
  axios.post<ListCampaignSubpublisherResponse>(
    `${baseURL}/${id}/subpublisher/bulk`,
    body
  )
